export const authFetch = (url, opts = {}) =>
    fetch(url, { credentials: "include", ...opts }).then((r) => {
      if (r.status === 401) throw new Error("unauth");
      return r;
    });
  